if (!customElements.get('dsv-site-footer')) {
  customElements.define('dsv-site-footer', class extends HTMLElement {
    connectedCallback() {
      if (this.viewport) return;
      this.viewport = matchMedia('(max-width:749px)');
      this.groups = [...this.querySelectorAll('.dsvf-group, .dsvf-contact')];
      this.sync = () => this.groups.forEach(group => {
        group.open = !this.viewport.matches;
        const summary = group.querySelector('summary');
        if (summary) summary.tabIndex = this.viewport.matches ? 0 : -1;
      });
      this.keepDesktopOpen = event => {
        const summary = event.target.closest('summary');
        if (!this.viewport.matches && summary && this.groups.includes(summary.parentElement)) event.preventDefault();
      };
      this.sync();
      this.viewport.addEventListener('change', this.sync);
      this.addEventListener('click', this.keepDesktopOpen);
    }
    disconnectedCallback() {
      this.viewport?.removeEventListener('change', this.sync);
      this.removeEventListener('click', this.keepDesktopOpen);
      this.viewport = null;
    }
  });
}
